import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import {
    CentralLoginAccountSettingsComponent
} from '@app/modules/central-login/pages/central-login-account-settings.component';

import { Toaster } from 'psd-common';
import {
    AuthenticationService,
    CookieService,
    DataListService,
    UserDTO,
    Language,
    CommonUtil,
    CommonUserService
} from 'psd-common';
import { Subscription } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { PublicUtil } from '@app/modules/central-login/util/public-util';

@Component({
    selector: 'central-login-account-settings-preferences',
    templateUrl: 'central-login-account-settings-preferences.component.html'
})
export class CentralLoginAccountSettingsPreferencesComponent extends CentralLoginAccountSettingsComponent implements OnInit {
    public preferencesForm: FormGroup;
    public submitting: boolean = false;
    public submitted: boolean = false;
    public currentUser: UserDTO;
    public requestCentralAccessToken: string;
    public requestCentralRefreshToken: string;
    public CommonUtil: typeof CommonUtil = CommonUtil;
    public languages: Array<Language>;
    public languageOptions: Array<any>;

    private navigationSubscription: Subscription;

    constructor(
        @Inject(DOCUMENT) private document: Document,
        private renderer: Renderer2,
        private toaster: Toaster,
        private route: ActivatedRoute,
        private formBuilder: FormBuilder,
        private router: Router,
        private translateService: TranslateService,
        private userService: CommonUserService,
        private dataListService: DataListService,
        public authenticationService: AuthenticationService,
        public cookieService: CookieService) {
        super(cookieService, authenticationService);
    }

    ngOnInit() {
        this.renderer.removeClass(this.document.body, 'login');
        this.renderer.addClass(this.document.body, 'central-login__dashboard');

        this.navigationSubscription = this.router.events.subscribe((e: any) => {
            if (e instanceof NavigationEnd) {
                this.initialisePage();
            }
        });

        this.initialisePage();
    }

    initialisePage() {
        this.dataListService.getLanguages().subscribe(languages => {
            this.languages = languages;
            this.loadLanguages();
        });

        this.checkCookiesAndSetUser();
    }

    getCurrentUser() {
        this.currentUser = PublicUtil.getCentralUser();
        this.preferencesForm = this.formBuilder.group({
            language: [this.currentUser.language != null ? this.currentUser.language.toLowerCase() : null, [Validators.required]]
        });
    }

    get _languageForm() {
        return this.preferencesForm.controls;
    }

    savePreferences() {
        let centralAccessToken = this.cookieService.getCentralCookie('central_access_token', environment.production);
        this.submitting = true;

        if (this.preferencesForm.invalid) {
            this.submitting = false;
            return;
        }

        let json = JSON.parse(JSON.stringify(this.preferencesForm.value, null, 4));
        this.currentUser.language = json.language;
        this.userService.updateCentralUser(this.currentUser, centralAccessToken).subscribe(_result => {
            this.toaster.success(this.translateService.instant('central-login.account.settings.account.preferences.update.success'));
            this.submitting = false;
            this.translateService.use(_result.language.toLowerCase());
            this.router.navigate(['/central-login/account-settings/preferences']);
        });
    }

    loadLanguages() {
        this.languageOptions = [];
        for (let language of this.languages) {
            this.languageOptions.push({
                id: language.code,
                text: language.name,
                object: language.code
            });
        }
    }

    ngOnDestroy() {
        if (this.navigationSubscription) {
            this.navigationSubscription.unsubscribe();
        }
    }
}
